import { render, staticRenderFns } from "./com-box3.vue?vue&type=template&id=31c7488d&scoped=true&"
import script from "./com-box3.vue?vue&type=script&lang=js&"
export * from "./com-box3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7488d",
  null
  
)

export default component.exports